module.exports = __webpack_public_path__ + "img/help.b30f248f.png";